export class TypeEquipement {
    id: number;
    nom: string;

    public constructor(init?: Partial<TypeEquipement>) {
      Object.assign(this, init);
    }
  }
